import { useState } from 'react';
import { Buttons, NotificationModal } from 'components';
import * as S from './PublisherPayments.styled';

export const PayPalDetails = ({ paypalEmail, onHandleDeletePayment, onSetIsPayPalOpen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!paypalEmail)
    return (
      <>
        <S.SmallText>
          PayPal fees will be included in every transaction.
          <br />
          For detailed information, please refer to PayPal&apos;s website.
          <br />
          Starting December 1, 2018, PayPal payments of up to USD 2,000 per month will be free of
          charge from Appnext. For any amounts exceeding USD 2,000 per month, Appnext will charge an
          additional 2% transfer fee on top of the PayPal fees.
        </S.SmallText>
        <Buttons.SecondaryNormal
          id='set_up_paypal'
          style={{ marginTop: '16px' }}
          onClick={() => onSetIsPayPalOpen(true)}
        >
          Set Up
        </Buttons.SecondaryNormal>
      </>
    );

  return (
    <>
      {isModalOpen ? (
        <NotificationModal
          title='Allert'
          id='confirm_delete_paypal'
          iconType={NotificationModal.iconTypes.error}
          iconSign='?'
          onConfirm={() => onHandleDeletePayment(2)}
          onCancel={() => setIsModalOpen(false)}
          confirmBtnType={NotificationModal.btnTypes.DestructiveNormal}
          confirmBtnText='Delete'
          cancelBtnType={NotificationModal.btnTypes.SecondaryNormal}
          cancelBtnText='Cancel'
        >
          Delete {paypalEmail} ?
        </NotificationModal>
      ) : null}
      <S.SmallText>PayPal account</S.SmallText>
      <S.SubHeading>{paypalEmail}</S.SubHeading>
      <S.ButtonsWrap>
        <Buttons.SecondaryNormal
          style={{ marginTop: '16px' }}
          id='change_paypal'
          onClick={() => onSetIsPayPalOpen(true)}
        >
          Change
        </Buttons.SecondaryNormal>
        <Buttons.SecondaryNormal
          style={{ margin: '16px 0 0 24px' }}
          id='delete_paypal'
          onClick={() => setIsModalOpen(true)}
        >
          Delete
        </Buttons.SecondaryNormal>
      </S.ButtonsWrap>
    </>
  );
};
